import styled, { css } from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

import theme from '@themes/default';

export const VoucherDiscountInfoWrapper = styled.div<{
  newDesign: boolean;
  newVoucherDesign: boolean;
  showArrow: boolean;
  isUnderSelectBox?: boolean;
}>`
  min-height: 4rem;
  display: flex;
  position: relative;
  justify-content: space-between;
  background-color: ${({ newVoucherDesign }) =>
    newVoucherDesign ? '#ffedf6' : `${theme.color.background.highlight}08`};
  padding: 0.75rem;

  margin: ${(props) =>
    props.isUnderSelectBox ? '0 0 0.75rem 0' : '0.5rem 0 0.75rem 0'};
  ${({ newDesign }) =>
    newDesign
      ? css`
          @media (min-width: ${breakpoints.md}) {
            margin: 1rem 0 0.75rem 0;
          }
        `
      : css`
          margin: 0.75rem 0;

          @media (min-width: ${breakpoints.md}) {
            margin: 0.75rem 0;
          }
        `}
  ${({ newVoucherDesign }) =>
    newVoucherDesign &&
    css`
      border-radius: 2px;
      align-items: center;
    `}
    ${({ showArrow }) =>
    showArrow &&
    css`
      ::after {
        content: ' ';
        height: 1rem;
        width: 1rem;
        background-color: #ffedf6;
        border-radius: 2px;
        position: absolute;
        top: -5px;
        right: 1.3rem;
        transform: rotate(45deg);
      }
    `};
`;

export const DiscountInfoDescription = styled.div`
  text-align: left;
`;

export const DiscountAmmountWrapper = styled.span<{
  newDesign: boolean;
  isStressed: boolean;
  color?: string;
}>`
  color: ${({ color = theme.color.text.highlight }) => color};
  margin-right: 5px;

  ${({ newDesign }) =>
    newDesign
      ? theme.typography.labelRegular
      : css`
          font-weight: bold;
        `}

  ${({ isStressed }) =>
    isStressed &&
    css`
      line-height: 1.5rem;
      font-size: 1.25rem;
      font-weight: 500;
    `}
`;

export const CodeWrapper = styled.span<{ newDesign: boolean }>`
  text-transfrom: uppercase;
  color: ${theme.color.text.primary};

  ${({ newDesign }) =>
    newDesign
      ? theme.typography.labelRegular
      : css`
          font-weight: bold;
        `}
`;

export const TermsWrapper = styled.div<{
  newDesign: boolean;
}>`
  font-size: 0.75rem;
  color: ${theme.color.text.tertiary};
  font-weight: normal;

  @media (min-width: ${breakpoints.sm}) {
    align-items: center;
  }

  ${({ newDesign }) =>
    !newDesign &&
    css`
      @media (min-width: ${breakpoints.lg}) {
        margin-top: 0.2rem;
      }
    `}
`;

export const TextWrapper = styled.div<{
  newDesign: boolean;
  isStressed: boolean;
  newVoucherDesign: boolean;
}>`
  margin-bottom: 0.125rem;
  color: ${theme.color.text.secondary};
  display: flex;
  flex-wrap: wrap;

  ${({ newDesign }) =>
    newDesign
      ? css`
          ${theme.typography.labelRegular400}
        `
      : css`
          ${theme.typography.labelLarge}
          font-weight: 500;
        `}

  ${({ newVoucherDesign }) =>
    newVoucherDesign &&
    css`
      flex-direction: column;
      align-items: flex-start;

      @media (min-width: ${breakpoints.md}) {
        flex-direction: row;
        align-items: flex-end;
      }
    `}
`;

export const VoucherDiscountIconWrapper = styled.div<{
  voucherNewDesign: boolean;
}>`
  height: 2.25rem;
  margin: 0 0 0 2rem;

  @media (min-width: ${breakpoints.sm}) {
    margin: 0 0 0 1rem;
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 0 0 0 2.5rem;
  }

  ${({ voucherNewDesign }) =>
    voucherNewDesign &&
    css`
      height: auto;
      z-index: 1;
      > div {
        font-size: 0.9rem;
        font-weight: 500;
        width: 3rem;
        height: 3rem;
        > span {
          margin: 0;
        }
      }
    `}
`;

export const InfoIconWrapper = styled.span<{ newDesign: boolean }>`
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
  margin-left: 4px;
  position: relative;
  top: 2px;

  @media (min-width: ${breakpoints.sm}) {
    margin-top: 0;
  }
`;

export const InstructionTextWrapper = styled.span<{
  newDesign: boolean;
  newVoucherDesign: boolean;
}>`
  padding-right: 0.3rem;

  ${({ newDesign }) =>
    newDesign
      ? css`
          ${theme.typography.labelSmall400}
          color: ${theme.color.text.secondary};
        `
      : css`
          ${theme.typography.labelRegular400}
        `}

  ${({ newVoucherDesign }) =>
    newVoucherDesign &&
    css`
      color: ${theme.color.text.tertiary};
    `}
`;
